function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function () {
  'use strict';

  angular.module('wsLrs.services').factory("CardQueryResource", ["$http", "$routeParams", "Api", "CardRegistry", "Demo", "QueryWithProgress", "ShareUtils", "User", "Utils", "ViewDashboardsAs", "$q", "$location", '$rootScope', 'wsEventNames', function ($http, $routeParams, Api, CardRegistry, Demo, QueryWithProgress, ShareUtils, User, Utils, ViewDashboardsAs, $q, $location, $rootScope, wsEventNames) {
    var self = {
      _cachedStateIdPromise: null,
      getOrgStateId: function getOrgStateId() {
        if (!self._cachedStateIdPromise) {
          self._cachedStateIdPromise = $http.get(Api.url("/state-id")).then(function (response) {
            return response.data.stateId;
          });
        }
        return self._cachedStateIdPromise;
      },
      get: function get(pathOrCfg, cardId, params, cardToPreview) {
        var path = pathOrCfg;

        // First arg could just be args packed up into a single config object
        if (_typeof(pathOrCfg) === "object") {
          path = pathOrCfg.path;
          cardId = pathOrCfg.cardId;
          params = pathOrCfg.params;
          cardToPreview = pathOrCfg.cardToPreview;
        }
        return self.getConfig(cardId, params, cardToPreview).then(function (config) {
          path = cardToPreview ? path + "/preview" : path;
          if (!config.params.filter && $location.search().filter) {
            config.params.filter = $location.search().filter;
          }
          var pathWithParams = Utils.appendParams(Api.url(path), config.params);
          return $http.get(pathWithParams, {
            timeout: self._canceler.promise
          });
        });
      },
      // progressChannel is optional, will default to cardId if not provided
      getWithProgress: function getWithProgress(pathOrCfg, cardId, params, cardToPreview, progressChannel) {
        var path = pathOrCfg;

        // First arg could just be args packed up into a single config object
        if (_typeof(pathOrCfg) === "object") {
          path = pathOrCfg.path;
          cardId = pathOrCfg.cardId;
          params = pathOrCfg.params;
          cardToPreview = pathOrCfg.cardToPreview;
          progressChannel = pathOrCfg.progressChannel;
        }
        $rootScope.$broadcast(wsEventNames.dataTable.updateSort, params && params.order_by);

        // If the cardToPreview has a defaultSort, pass that back
        // This fixes the use-case where preview / card views on dashboards didn't respect the default sort
        if (params && !params.hasOwnProperty('order_by')) {
          var order_by = Utils._try(function () {
            return cardToPreview.configuration.defaultSort;
          }, null);
          if (order_by) {
            params = Object.assign({}, params, {
              order_by: order_by
            });
          }
        }
        return self.getConfig(cardId, params, cardToPreview).then(function (config) {
          path = cardToPreview ? path + "/preview" : path;
          var paths = _.isArray(path) ? path : [path];
          var pathsWithParams = _.map(paths, function (path) {
            if (!config.params.filter && $location.search().filter) {
              config.params.filter = $location.search().filter;
            }
            return Utils.appendParams(Api.url(path), config.params);
          });
          return QueryWithProgress.fetch(pathsWithParams, progressChannel || cardId);
        });
      },
      _canceler: $q.defer(),
      cancelAllOutstanding: function cancelAllOutstanding() {
        self._canceler.resolve();
        self._canceler = $q.defer();
        QueryWithProgress.cancelOutstanding();
      },
      getConfig: function getConfig(cardId, params, cardToPreview) {
        params = params || {};
        return self.getOrgStateId().then(function (orgStateId) {
          // Note if we're in "demo" mode
          params.demo = Demo.isDemoMode() || !!$routeParams.demo;
          if (cardId) {
            params.cardId = cardId;
          }

          // Incorporate the card update date to prevent caching old configs
          if (CardRegistry.has(params.cardId)) {
            var updated = CardRegistry.get(params.cardId).updated;
            if (updated) {
              params.lastUpdated = new Date(updated).getTime();
            }
          }

          // Include current user id, in the case of someone logging in as different accounts
          var currentUser = User.get();
          if (currentUser && currentUser.user) {
            params.uid = currentUser.user.id;
          }

          // Override user id with any impersonated user, if that feature is active
          if (ViewDashboardsAs.isActive && ViewDashboardsAs.selectedUser) {
            params.uid = ViewDashboardsAs.selectedUser.id;
            // Always cache bust when using view dashboards as, to ensure the
            // preview is fully up to date...
            params.cacheBust = Utils.randomId(12);
          }
          if (orgStateId) {
            params.stateId = orgStateId;
          }
          if (cardToPreview) {
            params.cardId = null;
            params.config = angular.copy(cardToPreview.configuration);

            //only pass the measure id so we don't exceed the url length limit
            if (params.config.measures) {
              params.config.measures = _.map(params.config.measures, function (m) {
                return m.id ? {
                  id: m.id
                } : m;
              });
            }
            //do this for spider chart's overlay (another list of measures)
            if (params.config.overlay && params.config.overlay.measures) {
              params.config.overlay.measures = _.map(params.config.overlay.measures, function (m) {
                return m.id ? {
                  id: m.id
                } : m;
              });
            }
          }
          return {
            params: params
          };
        });
      },
      getDownloadUrlWithFilters: function getDownloadUrlWithFilters(basePath, cardId, config, filters) {
        if ($location.search().filter) {
          if (!filters.and) {
            filters.and = [];
          }
          filters.and.push($location.search().filter);
        }
        var url = basePath + (cardId === 'preview' ? '/preview?config=' + encodeURIComponent(JSON.stringify(config)) : '?cardId=' + cardId) + (filters ? '&filter=' + encodeURIComponent(JSON.stringify(filters)) : '') + (Demo.isDemoMode() || !!$routeParams.demo ? '&demo=true' : '') + (ShareUtils.hasShareKey() ? '&shareKey=' + ShareUtils.getShareKey() : '');
        return Api.url(url);
      },
      getDownloadUrl: function getDownloadUrl(basePath, cardId, config) {
        return Api.url(basePath + (cardId === 'preview' ? '/preview?config=' + encodeURIComponent(JSON.stringify(config)) : '?cardId=' + cardId) + ($location.search().filter ? '&filter=' + encodeURIComponent($location.search().filter) : '') + (Demo.isDemoMode() || !!$routeParams.demo ? '&demo=true' : '') + (ShareUtils.hasShareKey() ? '&shareKey=' + ShareUtils.getShareKey() : ''));
      }
    };
    return self;
  }]);
})();
